module.exports = __webpack_public_path__ + "static/media/glenveagh1.2e8e85af.png";